<template>
  <div>
    <br />
    <card>
      <b-toast no-close-button b-toaster-top-right variant="success" :solid="true" id="email-sent">
        <strong>
          {{ $t("email-sent") }}
        </strong>
      </b-toast>

      <div class="px-4">
        <div>
          <h5>{{ $t("title") }}</h5>
        </div>

        <div
          v-if="
            isOnSimulationPage &&
              $store.getters.getCurrentCaseNumber !=
                $store.getters.getCurrentCaseNumberForPlayers &&
              $store.getters.getCurrentCaseNumberForPlayers <= $store.getters.getNumberOfCases
          "
        >
          <strong
            >{{ $t("playerscasenumber") }}:
            {{ $store.getters.getCurrentCaseNumberForPlayers }}.</strong
          >
          <br />
          <br />
        </div>

        <div v-if="showOpenSurveyButton">
          <card shadow>
            {{ $t("opensurveyquestionshelp") }}
            <br />
            <base-button
              style="margin: 12px 0;"
              type="success"
              v-on:click="openSurveyQuestions()"
              >{{ $t("opensurveyquestions") }}</base-button
            >
          </card>
          <br />
        </div>

        <div v-if="welcomePage">
          <br />
          <span v-html="facilitatorinfo" />
          <br />
        </div>

        <div v-if="selfEvaluationPage && $store.state.main.playerIsOnlyFacilitator">
          <br />
          {{ $t("onlyfacilitator") }}
          <br />
          <br />
        </div>

        <div v-if="showOpenReportingText">
          <base-button
            type="primary"
            size="sm"
            style="white-space: normal; margin: 2px;"
            v-on:click="openReporting()"
          >{{ $t("openreporting") }}</base-button>
          <br />
          <br />
        </div>

        <div v-if="showGameOpenText">
          <card shadow>
            <span v-html="gameclosed"></span>
            <br />
            <base-button style="white-space: normal;" type="success" v-on:click="openGame()">{{
              $t("opengame")
            }}</base-button>
          </card>
          <br />
        </div>

        <FacilitatorInstructions />

        <br />

        <span v-if="showPausedPlayersHelp">
          <base-alert type="secondary">
            <span class="alert-inner--icon"><i class="ni ni-air-baloon"></i></span>
            <span class="alert-inner--text">{{ $t("pausedplayerforwardhelp") }}</span>
          </base-alert>
          <br />
        </span>

        <div v-if="playersExist">
          <base-button
            style="white-space: normal;"
            size="sm"
            type="primary"
            @click="editPlayersVisible = !editPlayersVisible"
            >{{ playerManagementButtonText }}&nbsp;<font-awesome-icon
              :icon="editPlayersVisible ? 'minus' : 'plus'"
          /></base-button>
          <b-collapse id="collapse-player-edit" v-model="editPlayersVisible">
            <div class="row" v-for="player in $store.getters.getPlayers" :key="player.id">
              <div class="col-4">
                <span
                  style="line-height: 1.0 !important;"
                  class="d-inline-block"
                  tabindex="0"
                  v-b-tooltip.hover
                  :title="player.email"
                >
                  <small>
                    <strong>{{ player.nick_name }}</strong>
                    ({{ player.first_name }} {{ player.last_name }})
                  </small>
                </span>
              </div>

              <div class="col-8 align-self-center">
                <div v-if="!$store.state.main.game.reportingOpen">
                  <base-button
                    size="sm"
                    style="margin: 2px;"
                    type="secondary"
                    v-on:click="openEditDialog(player)"
                    >{{ $t("edit") }}</base-button
                  >
                  <base-button
                    v-if="
                      !player.facilitator && $store.state.main.game.currentCaseNumberForPlayers > 0
                    "
                    size="sm"
                    style="margin: 2px;"
                    :type="getPauseButtonType(player)"
                    v-on:click="togglePause(player)"
                    >{{ getPauseText(player) }}</base-button
                  >
                  <base-button
                    v-if="!player.facilitator"
                    size="sm"
                    style="margin: 2px;"
                    type="secondary"
                    v-on:click="openReturnLinkDialog(player)"
                    >{{ $t("returnlink") }}</base-button
                  >
                </div>
                <div v-else>
                  <base-button
                    size="sm"
                    style="margin: 2px;"
                    type="secondary"
                    v-on:click="sendEmail(player, true)"
                    v-if="!player.robot"
                    >{{ $t("resendemail") }}</base-button
                  >
                </div>
              </div>
            </div>
            <br />
            <div v-if="!$store.state.main.game.reportingOpen">
              <small style="white-space: break-spaces;">{{ $t("pausehelp") }}</small>
            </div>
          </b-collapse>
        </div>

        <SuggestionsForFacilitator v-if="beginPage || isGameOn" />

        <div v-if="modalEditPlayer">
          <EditGameDialog v-bind:editplayer="editplayer" />
        </div>

        <div v-if="modalReturnLink">
          <ReturnLinkDialog v-bind:player="returnLinkPlayer" />
        </div>

        <br />

        <div v-if="playersExist && isGameOn">
          <base-button
            style="white-space: normal;"
            size="sm"
            type="primary"
            @click="toggleSpeakingTurnsUI"
          >
            {{ $t("speaking-turns") }}&nbsp;<font-awesome-icon
              :icon="$store.state.main.showSpeakingTurnsUI ? 'minus' : 'plus'"
            />
          </base-button>
          <b-collapse id="collapse-speaking-turns" v-model="$store.state.main.showSpeakingTurnsUI">
            <SpeakingTurns />
          </b-collapse>
        </div>

        <base-button
          size="sm"
          type="warning"
          style="margin: 2px; margin-bottom: 1rem;"
          v-on:click="gamesAdmin()"
          v-if="!adminPage"
        >{{ $t("gamesadmin") }}</base-button>

        <br/>

        <OpenAdminGuideButton />
        
        <br />
        <div v-if="showGameCode" class="text-center">
          <small>{{ $t("addressofgame") }} {{ gameUrl }}</small>
        </div>
        <div v-if="showGameCode && $store.state.main.userViewObserverLink" class="text-center">
          <small>{{ $t("observeaddress") }} {{ observeUrl }}</small>
        </div>
      </div>
    </card>
    <CheckToken />
  </div>
</template>

<script>
import Swal from "sweetalert2";
import Vue from "vue";
import FacilitatorInstructions from "@/components/FacilitatorInstructions.vue";
import SpeakingTurns from "@/components/SpeakingTurns.vue";
import { mapGetters } from "vuex";
import {
  updatePlayerPaused,
  updateGameOpen,
  updateGameReportingOpen,
  emailReportLink,
  createGameCaseOptions
} from "../services/APIService";
import EditGameDialog from "./EditGameDialog";
import ReturnLinkDialog from "./ReturnLinkDialog";
import CheckToken from "./CheckToken";
import OpenAdminGuideButton from "@/components/OpenAdminGuideButton.vue";
import SuggestionsForFacilitator from "@/components/SuggestionsForFacilitator.vue";

const union = require("lodash.union");

export default {
  data: function() {
    return {
      modalEditPlayer: false,
      modalReturnLink: false,
      editplayer: null,
      returnLinkPlayer: null,
      editPlayersVisible: false
    };
  },
  components: {
    EditGameDialog,
    ReturnLinkDialog,
    CheckToken,
    FacilitatorInstructions,
    OpenAdminGuideButton,
    SpeakingTurns,
    SuggestionsForFacilitator
  },
  mounted() {
    this.$bus.$on("close-edit-game-dialog", () => {
      this.modalEditPlayer = false;
    });
    this.$bus.$on("close-return-link-dialog", () => {
      this.modalReturnLink = false;
    });
  },
  beforeDestroy() {
    this.$bus.$off("close-edit-game-dialog");
    this.$bus.$off("close-return-link-dialog");
  },
  computed: {
    ...mapGetters(["getSurveyAnswers"]),
    gameUrl() {
      return window.location.origin + "/gamecode/" + this.$store.state.main.game.gameCode;
    },
    gameclosed() {
      if (this.$store.getters.getIsClassic) {
        return this.$t("gameclosed");
      } else {
        return this.$t("rps-gameclosed");
      }
    },
    facilitatorinfo() {
      if (this.$store.getters.getIsClassic) {
        return this.$t("facilitatorinfo");
      } else {
        return this.$t("rps-facilitatorinfo");
      }
    },
    observeUrl() {
      return window.location.origin + "/observe/gamecode/" + this.$store.state.main.game.gameCode;
    },
    adminPage() {
      return this.$router.currentRoute.name === "admingames";
    },
    welcomePage() {
      return this.$router.currentRoute.name === "PlayerWelcome";
    },
    reportingPage() {
      return (
        this.$router.currentRoute.name.startsWith("reporting") ||
        this.$router.currentRoute.name === "RpsReporting"
      );
    },
    askGameCodePage() {
      return (
        this.$router.currentRoute.name === "gamecode" || this.$router.currentRoute.name === "home"
      );
    },
    selfEvaluationPage() {
      return this.$router.currentRoute.name === "SelfEvaluation";
    },
    lastPage() {
      return (
        this.$router.currentRoute.name === "LastPage" ||
        this.$router.currentRoute.name === "RpsLastPage"
      );
    },
    beginPage() {
      return (
        this.$router.currentRoute.name === "FirstPage" ||
        this.$router.currentRoute.name === "RpsFirstPage"
      );
    },
    gamePage() {
      return (
        this.$router.currentRoute.name === "Game" || this.$router.currentRoute.name === "RpsGame"
      );
    },
    introPage() {
      return this.$router.currentRoute.name === "intro";
    },
    playersExist() {
      return this.$store.getters.getNumberOfPlayers > 0;
    },
    openStatusText() {
      return this.$store.state.main.game.open ? this.$t("game-open") : this.$t("game-closed");
    },
    openButtonText() {
      return this.$store.state.main.game.open ? this.$t("close-game") : this.$t("open-game");
    },
    showOpenReportingText() {
      if (this.lastPage && !this.$store.state.main.game.reportingOpen) {
        // If reporting is closed and on last page, show text and button
        return true;
      } else {
        return false;
      }
    },
    showGameCode() {
      if (this.$store.state.main.game.practice) {
        return false;
      }
      return (
        this.welcomePage ||
        this.selfEvaluationPage ||
        this.reportingPage ||
        this.beginPage ||
        this.lastPage ||
        this.introPage ||
        this.gamePage
      );
    },
    showGameOpenText() {
      if (this.$store.state.main.game.gameCode === "" || this.welcomePage || this.introPage) {
        // No game yet or in intro or Welcome page, don't show
        return false;
      } else {
        return !this.$store.state.main.game.open;
      }
    },
    showOpenSurveyButton() {
      if (!this.isOnSimulationPage || !this.$store.state.main.game.enableSurvey) {
        return false;
      } else {
        const currentCase = this.$store.getters.getCurrentCase;
        const options = this.$store.getters.getGameCaseOptionsForCase(currentCase.case);

        if (!options || !options[0] || !options[0].show_survey_questions) {
          return true;
        } else {
          return false;
        }
      }
    },
    isOnSimulationPage() {
      return !(
        this.welcomePage ||
        this.askGameCodePage ||
        this.selfEvaluationPage ||
        this.reportingPage ||
        this.beginPage ||
        this.lastPage ||
        this.introPage
      );
    },
    isGameOn() {
      // Show question only if we are on a game page
      if (this.$store.getters.getIsClassic) {
        return (
          !this.reportingPage &&
          this.$store.getters.getCurrentCaseNumber > 0 &&
          this.$store.getters.getCurrentCaseNumber <= this.$store.getters.getNumberOfCases
        );
      } else {
        return (
          !this.reportingPage &&
          this.$store.getters.getCurrentCaseNumber > 0 &&
          this.$store.getters.getCurrentCaseNumber <= this.$store.getters.getNumberOfRPSCases
        );
      }
    },
    getThisCase() {
      return this.$store.getters.getCaseByCaseNumber(this.$store.getters.getCurrentCaseNumber);
    },
    getNextCase() {
      return this.$store.getters.getCaseByCaseNumber(this.$store.getters.getCurrentCaseNumber + 1);
    },
    facilitatorInstructions() {
      if (this.reportingPage) {
        return this.$store.getters.getScenarioInCurrentLocale.reporting_facilitator_instructions;
      }

      if (this.selfEvaluationPage) {
        return this.$store.getters.getScenarioInCurrentLocale
          .self_evaluation_facilitator_instructions;
      }

      if (this.beginPage) {
        return this.$store.getters.getScenarioInCurrentLocale.begin_page_facilitator_instructions;
      }

      if (this.lastPage) {
        return this.$store.getters.getScenarioInCurrentLocale.last_page_facilitator_instructions;
      }

      if (this.isGameOn) {
        return this.getThisCase.facilitatorInstructions;
      } else {
        return null;
      }
    },
    playerManagementButtonText() {
      let text = this.$t("playermanagement") + " ";

      const pausedPlayers = this.$store.getters.countPausedPlayers;

      if (!this.reportingPage && pausedPlayers > 0) {
        text += "(";
        text += this.$t("pausedplayers") + ": ";
        text += pausedPlayers;
        text += ")";
      }

      return text;
    },
    showPausedPlayersHelp() {
      return this.$store.getters.countPausedPlayers && !this.reportingPage && !this.lastPage;
    }
  },
  methods: {
    getPauseText(player) {
      if (player.paused) {
        return this.$t("unpause");
      } else {
        return this.$t("pause");
      }
    },
    getPauseButtonType(player) {
      if (player.paused) {
        return "success";
      } else {
        return "info";
      }
    },
    openEditDialog(player) {
      this.modalEditPlayer = true;
      this.editplayer = player;
    },
    openReturnLinkDialog(player) {
      this.modalReturnLink = true;
      this.returnLinkPlayer = player;
    },
    togglePause(player) {
      let missingCases = [];

      if (player.paused) {
        if (this.$store.getters.getIsClassic) {
          // We can only unpause a player with no missing nominations or survey answers.
          const missingNominations = this.$store.getters.getSomePlayersCasesWithoutNominations(
            player.id
          );
          const missingSurveys = this.$store.getters.getSomePlayersCasesWithoutSurvey(player.id);
          missingCases = union(missingNominations, missingSurveys);

          missingCases.sort((a, b) => a - b);
        } else {
          // RPS
          // We can only unpause a player with no missing RPS answers.
          missingCases = this.$store.getters.getSomePlayersCasesWithoutRPSAnswer(player.id);
        }
      }

      if (missingCases.length > 0) {
        let caseString = "";

        for (let i = 0; i < missingCases.length; i++) {
          if (i > 0) {
            caseString += ", ";
          }

          caseString += missingCases[i];
        }

        Swal.fire({
          text: this.$t("cantunpause") + caseString,
          allowOutsideClick: false,
          confirmButtonText: this.$t("cancel")
        });
        return;
      }

      const newPausedState = !player.paused;

      updatePlayerPaused(player.id, newPausedState, this.$store.state.main.game.gameCode).then(
        resp => {
          this.$store.dispatch("updatePlayers");
        }
      );
    },
    async openGame() {
      // Show a warning if everyone have not done self evaluation yet
      if (
        this.$store.getters.getIsClassic &&
        !this.$store.getters.haveAllPlayersDoneSelfEvaluation(1)
      ) {
        Swal.fire({
          text: this.$t("opengameselfevaluationsmissing"),
          showDenyButton: true,
          confirmButtonText: this.$t("opengame"),
          denyButtonText: this.$t("cancel"),
          allowOutsideClick: false
        }).then(result => {
          if (result.isConfirmed) {
            // Open game
            updateGameOpen(
              this.$store.state.main.game.id,
              this.$store.state.main.game.gameCode,
              true
            );

            this.$store.dispatch("updateGame");
          } else if (result.isDenied) {
            // Do nothing
          }
        });
      } else {
        updateGameOpen(this.$store.state.main.game.id, this.$store.state.main.game.gameCode, true);
      }
    },
    openSurveyQuestions() {
      const currentCase = this.$store.getters.getCurrentCase;

      createGameCaseOptions(
        this.$store.state.main.game.id,
        currentCase.case,
        this.$store.state.main.game.gameCode,
        true
      ).then(resp => {
        this.$store.dispatch("updateGameCaseOptions");
      });
    },
    openReporting() {
      let i = 0;

      // Amazon SES doesn't seem too happy if all emails are flooded, so let's keep a short pause
      this.$store.state.main.allPlayers.forEach(player => {
        i++;
        setTimeout(() => {
          this.sendEmail(player, false);
        }, 200 * i);
      });

      updateGameReportingOpen(
        this.$store.state.main.game.id,
        this.$store.state.main.game.gameCode,
        true,
        this.$store.state.main.allPlayers.length
      );
    },
    sendEmail(player, reportToSlack) {
      if (this.$store.state.main.game.practice) {
        // Don't send emails in practice game
        return;
      }

      if (player.robot) {
        this.$store.dispatch("log", "Player is robot, skipping sending email to " + player.email);
        return;
      }

      this.$store.dispatch("log", "Sending reporting email to " + player.email);

      if (reportToSlack) {
        // Manual sending, show toast
        this.$bvToast.show("email-sent");
      }

      let url = window.location.origin;
      if (!this.$store.getters.getIsClassic) {
        url += "/rps";
      }
      url += "/reporting/reportingcode/";

      emailReportLink(
        this.$store.state.main.game.gameCode,
        player.id,
        this.$i18n.locale,
        url,
        reportToSlack
      );
    },
    gamesAdmin() {
      this.$router.push("/admin/games/");
    },
    toggleSpeakingTurnsUI() {
      this.$store.commit({
        type: "setShowSpeakingTurnsUI",
        showSpeakingTurnsUI: !this.$store.state.main.showSpeakingTurnsUI
      });
    }
  }
};
</script>

<i18n>
{
  "en": {
    "title": "Facilitator tools",
    "help": "Tip: Click button to activate pause for a player. Other players do not need to wait for players who are in a pause. Also, paused players can advance before other players have done the nominations.",
    "gameclosed": "Click the button when everyone has answered and you want to proceed with the simulation.",
    "opengame": "Start simulation",
    "case": "case",
    "pause": "Pause",
    "unpause": "Unpause",
    "gamesadmin": "Exit simulation",
    "coming-up": "Coming up next",
    "selfevaluation": "Self-evaluation",
    "loginexpired": "Your login has expired. Please login again.",
    "playerwelcome": "Player information gathering",
    "close": "Close",
    "reports": "Report",
    "edit": "Edit",
    "openreporting": "Open reporting",
    "reporting": "Reports",
    "addressofgame": "Simulation address:",
    "facilitator-instructions": "Instructions for facilitators",
    "surveyquestions": "Survey questions for this case (updating)",
    "playersanswered": "Survey answered by",
    "playersnotanswered": "Not yet answered by",
    "pausehelp": "If a player has to step out during a game, you can pause the player. A paused player can advance on the simulation without waiting for others, and other players don't need to wait for a paused player to answer.",
    "resendemail": "Resend link to the report",
    "playermanagement": "Player management",
    "facilitatorinfo": "Typically facilitator acts only as a facilitator. If you wish to act as a facilitator and player, you can use other joining options.<br/><br/>The simulation can have simultaneously several facilitators. This can be used for familiarization or group facilitation. If you have several facilitators, decide who is responsible for advancing forward in the simulation.<br/><br/>YOU CAN TELL THE PLAYERS FOR EXAMPLE: 'please fill in your information and then we get to the self-evalution.' <br/><br/>Self-evaluation (the next phase) can be described to the players when several have already joined the simulation. You can see names of the joined players in the self-evaluation page.",
    "onlyfacilitator": "You decided to join the simulation only as a facilitator, so you cannot submit the self-evaluation.",
    "opensurveyquestions": "Show additional questions",
    "opensurveyquestionshelp": "Open two questions for players related to the topic of the situation. The questions should be opened when the discussion is about to finish. There is typically further discussion about the questions and their answers.",
    "cantunpause": "Player has not yet answered all cases. You can unpause the player, when the player has answered cases: ",
    "cancel": "Cancel",
    "playerscasenumber": "Players are at case",
    "pausedplayers": "paused players",
    "observeaddress": "Observer link:",
    "opengameselfevaluationsmissing": "All players have not yet answered to the self-evaluation. If you wish to start the simulation now, players who have already answered will begin the simulation. Rest of the players will join the simulation after they have answered. Are you sure you want to start the simulation?",
    "pausedplayerforwardhelp": "Paused players can move between the cases by clicking 'NEXT' button which is shown for paused players.",
    "rps-facilitatorinfo": "Typically facilitator acts only as a facilitator. If you wish to act as a facilitator and player, you can use other joining options.<br/><br/>The simulation can have simultaneously several facilitators. This can be used for familiarization or group facilitation. If you have several facilitators, decide who is responsible for advancing forward in the simulation.<br/><br/>YOU CAN TELL THE PLAYERS FOR EXAMPLE: 'please fill in your information and then we get to the simulation.'",
    "rps-gameclosed": "Click the button when everyone has joined and you want to proceed with the simulation.",
    "speaking-turns": "Tracking of speaking turns (optional)",
    "returnlink" : "Return link",
    "email-sent": "Email sent"
  },
  "fi": {
    "title": "Pelinjohtajan työkalut",
    "help": "Vinkki: Klikkaa pelaajaa laittaaksesi hänet tauolle. Muiden pelaajien ei tarvitse odottaa tauolla olevia pelaajia. Lisäksi tauolla olevat pelaajat voivat edetä simulaatiossa ilman, että heidän tarvitsee odottaa muita pelaajia.",
    "gameclosed": "Klikkaa painiketta, kun kaikki ovat vastanneet ja haluat edetä simulaatioon.",
    "opengame": "Aloita simulaatio",
    "case": "tilanne",
    "pause": "Tauolle",
    "unpause": "Simulaatioon",
    "gamesadmin": "Poistu simulaatiosta",
    "coming-up": "Seuraava tilanne",
    "selfevaluation": "Itsearviointi",
    "loginexpired": "Sisäänkirjautumisesi on vanhentunut. Kirjauduthan uudestaan.",
    "playerwelcome": "Pelaajan tiedot",
    "close": "Sulje",
    "reports": "Raportit",
    "edit": "Muokkaa",
    "openreporting": "Avaa raportit",
    "reporting": "Raportit",
    "addressofgame": "Simulaation osoite:",
    "facilitator-instructions": "Ohjeita pelinjohtajalle",
    "pausehelp": "Jos pelaaja joutuu poistumaan pelin aikana, voit laittaa pelaajan tauolle. Tällöin pelaaja voi vastata kysymyksiin etukäteen, ja muiden pelaajien ei tarvitse odottaa tauolla olevan pelaajan vastauksia.",
    "resendemail": "Uudelleenlähetä raporttilinkki",
    "playermanagement": "Pelaajien hallinta",
    "facilitatorinfo": "Yleensä pelinjohtaja toimii vain pelinjohtajana. Jos aiot osallistua myös pelaajana, käytä muita liittymisvaihtoehtoja.<br/><br/>Simulaatiossa voi olla useita pelinjohtajia yhtä aikaa. Tätä voidaan käyttää perehtymisessä tai jos pelinjohtajat haluavat fasilitoida ryhmää yhteistyössä. Jos simulaatiossa on useita pelinjohtajia, sopikaa kuka vastaa simulaation eteenpäin viemisestä.<br/><br/>PELAAJILLE VOI KERTOA ESIMERKIKSI: 'järjestelmä kysyy perustiedot, ja sen jälkeen päästään itsearvioinnin tekemiseen.' <br/><br/>Itsearviointi (seuraavalla sivulla) kannattaa kuvailla pelaajille, kun muutama pelaaja on liittynyt (näet liittyneiden pelaajien nimet seuraavan sivun alaosasta).",
    "onlyfacilitator": "Koska liityit simulaatioon pelkästään pelinjohtajana, et voi vastata tehtävään.",
    "opensurveyquestions": "Näytä lisäkysymykset",
    "opensurveyquestionshelp": "Avaa pelaajille kaksi kysymystä liittyen tilanteen aiheeseen. Kysymykset kannattaa avata, kun keskustelu on lopuillaan. Kysymyksistä ja niiden vastauksista käydään yleensä vielä jatkokeskustelu.",
    "cantunpause": "Pelaaja ei ole vielä vastannut kaikkiin tilanteisiin. Voit lopettaa tauon, kun pelaaja on antanut vastauksensa tilanteisiin: ",
    "cancel": "Peru",
    "playerscasenumber": "Pelaajat ovat tilanteessa",
    "pausedplayers": "pelaajia tauolla",
    "observeaddress": "Seuraajalinkki:",
    "opengameselfevaluationsmissing": "Kaikki pelaajat eivät ole vielä vastanneet itsearviointiin. Jos aloitat simulaation nyt, jo vastanneet pelaajat siirtyvät simulaatioon heti ja muut pelaajat vasta vastaamisen jälkeen. Haluatko varmasti aloittaa simulaation?",
    "pausedplayerforwardhelp": "Tauolla olevat pelaajat pääsevät etenemään tilanteissa painamalla heille näkyvää 'ETEENPÄIN'-nappia.",
    "rps-facilitatorinfo": "Yleensä pelinjohtaja toimii vain pelinjohtajana. Jos aiot osallistua myös pelaajana, käytä muita liittymisvaihtoehtoja.<br/><br/>Simulaatiossa voi olla useita pelinjohtajia yhtä aikaa. Tätä voidaan käyttää perehtymisessä tai jos pelinjohtajat haluavat fasilitoida ryhmää yhteistyössä. Jos simulaatiossa on useita pelinjohtajia, sopikaa kuka vastaa simulaation eteenpäin viemisestä.<br/><br/>PELAAJILLE VOI KERTOA ESIMERKIKSI: 'järjestelmä kysyy perustiedot, ja sen jälkeen päästään simulaatioon.'",
    "rps-gameclosed": "Klikkaa painiketta, kun kaikki ovat aulassa ja haluat edetä simulaatioon.",
    "speaking-turns": "Puheenvuorojen seuranta (valinnainen)",
    "returnlink" : "Paluulinkki",
    "email-sent": "Viesti lähetetty"    
  },
  "sv": {
    "title": "Verktyg för spelledare",
    "help": "Tips: Klicka på en spelare för att pausa hen. Andra spelare behöver inte vänta på spelare som är på paus. Dessutom kan pausade spelare fortsätta genom simuleringen utan att behöva vänta på andra spelare.",
    "gameclosed": "Klicka på knappen när alla har svarat och du vill fortsätta med simuleringen.",
    "opengame": "Starta simuleringen",
    "case": "status",
    "pause": "Pausa",
    "unpause": "Till simuleringen",
    "gamesadmin": "Lämna simulation",
    "coming-up": "Nästa situation",
    "selfevaluation": "Självskattning",
    "loginexpired": "Din inloggning har gått ut. Logga in igen.",
    "playerwelcome": "Spelarinformation",
    "close": "Stäng",
    "reports": "Rapporterna",
    "edit": "Redigera",
    "openreporting": "Öppna rapporterna",
    "reporting": "Rapporterna",
    "addressofgame": "Adress till simuleringen:",
    "facilitator-instructions": "Instruktioner för spelledare",
    "pausehelp": "Om en spelare måste gå ut under ett spel kan du pausa spelaren. En pausad spelare kan gå vidare i simuleringen utan att vänta på andra, och andra spelare behöver inte vänta på att en pausad spelare ska svara.",
    "resendemail": "Skicka länken till rapporten igen",
    "playermanagement": "Spelarhantering",
    "facilitatorinfo": "Vanligen agerar spelledare endast som spelledare. Om du vill agera som spelledare och spelare kan du använda andra sätt för att delta<br/><br/>Simuleringen kan ha flera spelledare samtidigt. Detta kan används för att bekanta sig med verktyget eller för att spelleda i grupp. Om du har flera spelledare, bestäm vem som är ansvarig för att gå vidare i simuleringen.<br/><br/>DU KAN TILL EXEMPEL SÄGA TILL SPELARNA: 'Vänligen fyll i dina uppgifter och sedan börjar vi med  självskattningen.' <br/><br/>Självskattning (nästa steg) kan beskrivas för spelarna när flera redan har anslutit sig till simuleringen. Du kan se namnen på de anslutna spelarna på självskattningssidan.",
    "onlyfacilitator": "Eftersom du bara gick med i simuleringen som spelledare  kan du inte svara på uppgiften.",
    "opensurveyquestions": "Visa ytterligare frågor",
    "opensurveyquestionshelp": "Öppna två frågor för spelarna som rör situationen. Frågorna bör öppnas när diskussionen är klar. Det uppstår  vanligtvis ytterligare diskussion om frågorna och svaren.",
    "cantunpause": "Spelaren har ännu inte svarat på alla situationer. Du kan pausa spelaren när spelaren har svarat på frågan: ",
    "cancel": "Avboka",
    "playerscasenumber": "Spelare aktiva i simuleringen",
    "pausedplayers": "pausade spelare",
    "observeaddress": "Länk till följare:",
    "pausedplayerforwardhelp": "Spelare som pausats kan flytta mellan frågorna genom att trycka på knappen 'NÄSTA' som visas för pausade spelare.",
    "rps-facilitatorinfo": "Vanligen agerar spelledare endast som spelledare. Om du vill agera som spelledare och spelare kan du använda andra sätt för att delta<br/><br/>Simuleringen kan ha flera spelledare samtidigt. Detta kan används för att bekanta sig med verktyget  eller för att spelleda i grupp. Om du har flera spelledare, bestäm vem som är ansvarig för att gå vidare i simuleringen.<br/><br/>DU KAN TILL EXEMPEL SÄGA TILL SPELARNA: 'Vänligen fyll i dina uppgifter och sedan börjar vi med simuleringen.'",
    "gameclosed": "Klicka på knappen när alla har gått med och du vill fortsätta med simuleringen.",
    "speaking-turns": "Spårning av talvändningar (valfritt)",
    "returnlink": "Återvändarlänk",
    "email-sent": "Email skickat"    
  },
 "de": {
    "title": "Spielmanager-Tools",
    "help": "Tipp: Klicken Sie auf die Schaltfläche, um die Pause für einen Spieler zu aktivieren. Andere Spieler müssen nicht auf Spieler warten, die sich in einer Pause befinden. Außerdem können pausierte Spieler fortschreiten, bevor andere Spieler die Nominierungen vorgenommen haben.",
    "gameclosed": "Klicken Sie auf die Schaltfläche, wenn alle geantwortet haben und Sie mit der Simulation fortfahren möchten.",
    "opengame": "Simulation starten",
    "case": "Fall",
    "pause": "Pause",
    "unpause": "Unpause",
    "gamesadmin": "Simulation verlassen",
    "coming-up": "Demnächst",
    "selfevaluation": "Selbstevaluation",
    "loginexpired": "Ihr Login ist abgelaufen. Bitte loggen Sie sich erneut ein.",
    "playerwelcome": "Sammeln von Spielerinformationen",
    "close": "Schließen",
    "reports": "Bericht",
    "edit": "Bearbeiten",
    "openreporting": "Öffnen Sie die Berichterstattung",
    "reporting": "Berichte",
    "addressofgame": "Simulationsadresse:",
    "facilitator-instructions": "Anweisungen für den Spielmanager",
    "pausehelp": "Wenn ein Spieler während eines Spiels aussteigen muss, können Sie den Spieler anhalten. Ein unterbrochener Spieler kann in der Simulation weitermachen, ohne auf andere zu warten, und andere Spieler müssen nicht auf die Antwort eines unterbrochenen Spielers warten.",  
    "resendemail": "Senden Sie den Link zum Bericht erneut",
    "playermanagement": "Spielerverwaltung",
    "facilitatorinfo": "Üblicherweise treten Spielleiter nur als Spielleiter auf. Wenn Sie als Spielleiter und Spieler agieren möchten, können Sie andere Möglichkeiten der Teilnahme nutzen <br/> <br/> Die Simulation kann mehrere Spielleiter gleichzeitig haben. Dies kann zum Kennenlernen des Tools oder zum Spielen in Gruppen genutzt werden. Wenn Sie mehrere Spielleiter haben, entscheiden Sie, wer für das Weiterkommen in der Simulation verantwortlich ist. <br/> <br/> SIE KÖNNEN ZUM BEISPIEL ZU DEN SPIELERN SAGEN: „Bitte tragen Sie Ihre Daten ein, dann fangen wir mit dem an Selbsteinschätzung.' <br/> <br/> Die Selbsteinschätzung (nächster Schritt) kann für die Spieler beschrieben werden, wenn sich bereits mehrere der Simulation angeschlossen haben. Sie können die Namen der verbundenen Spieler auf der Selbstbewertungsseite sehen.",
    "onlyfacilitator": "Sie haben sich entschieden, nur als Spielmanager an der Simulation teilzunehmen, sodass Sie die Selbstevaluation nicht einreichen können.",
    "opensurveyquestions": "Zusätzliche Fragen anzeigen",
    "opensurveyquestionshelp": "Öffnen Sie zwei Fragen für Spieler, die sich auf das Thema der Situation beziehen. Die Fragen sollten geöffnet werden, wenn die Diskussion zu Ende ist. In der Regel werden die Fragen und ihre Antworten weiter diskutiert.",
    "cantunpause": "Der Spieler hat noch nicht alle Fälle beantwortet. Sie können den Player anhalten, wenn der Player Fälle beantwortet hat: ",
    "cancel": "Stornieren",
    "playerscasenumber": "Spieler sind bei Fall",
    "pausedplayers": "Spieler angehalten",
    "observeaddress": "Beobachterin Link:",
    "opengameselfevaluationsmissing": "Alle Spieler haben noch nicht auf die Selbstevaluation geantwortet. Wenn Sie die Simulation jetzt starten möchten, starten Spieler, die bereits geantwortet haben, die Simulation. Der Rest der Spieler wird der Simulation beitreten, nachdem sie geantwortet haben. Möchten Sie die Simulation wirklich starten?",
    "pausedplayerforwardhelp": "Angehaltene Spieler können zwischen den Fällen wechseln, indem sie auf die Schaltfläche 'WEITER' klicken, die für angehaltene Spieler angezeigt wird.",
    "rps-facilitatorinfo": "Üblicherweise treten Spielleiter nur als Spielleiter auf. Wenn Sie als Spielleiter und Spieler agieren möchten, können Sie andere Möglichkeiten der Teilnahme nutzen <br/> <br/> Die Simulation kann mehrere Spielleiter gleichzeitig haben. Dies kann zum Kennenlernen des Tools oder zum Spielen in Gruppen genutzt werden. Wenn Sie mehrere Spielleiter haben, entscheiden Sie, wer für das Weiterkommen in der Simulation verantwortlich ist.",
    "rps-gameclosed": "Klicken Sie auf die Schaltfläche, wenn alle mitgemacht haben und Sie mit der Simulation fortfahren möchten.",
    "speaking-turns": "Verfolgung der Sprechbewegungen (optional)",
    "returnlink": "Rücksende-Link",
    "email-sent": "die Email wurde verschickt"
 },
  "ko": {
    "title": "퍼실리테이터 도구",
    "help": "Tip: 참여자의 플레이를 일시정지하려면 버튼을 클릭하십시오. 다른 참여자는 일시정지된 참여자를 기다리지 않아도 되며, 다른 참여자들이 모든 응답을 마칠 때까지 일시정지된 참여자는 계속 진행할 수 있습니다. ",
    "gameclosed": "모든 참여자가 응답을 완료하면 버튼을 눌러 시뮬레이션을 계속 진행하십시오.",
    "opengame": "시뮬레이션 시작하기",
    "case": "주제",
    "pause": "일시정지",
    "unpause": "다시 시작",
    "gamesadmin": "시뮬레이션 나가기",
    "coming-up": "Coming up next",
    "selfevaluation": "자기진단",
    "loginexpired": "로그인 시간이 초과되었습니다. 다시 로그인해주십시오.",
    "playerwelcome": "플레이어 정보 모으는 중...",
    "close": "닫기",
    "reports": "결과보고서",
    "edit": "수정",
    "openreporting": "결과보고서 공개",
    "reporting": "결과보고서",
    "addressofgame": "시뮬레이션 주소:",
    "facilitator-instructions": "퍼실리테이터 안내",
    "pausehelp": "참여자의 플레이를 일시정지하려면 버튼을 클릭하십시오. 다른 참여자는 일시정지된 참여자를 기다리지 않아도 되며, 다른 참여자들이 모든 응답을 마칠 때까지 일시정지된 참여자는 계속 진행할 수 있습니다",      
    "resendemail": "결과보고서 링크 재전송",
    "playermanagement": "플레이어 관리",
    "facilitatorinfo": "퍼실리테이터는 주로 퍼실리테이터 모드로만 접속합니다. 시뮬레이션에 플레이어로 함께 참여하고 싶다면 다른 옵션을 클릭하세요. <br/><br/> 두 명 이상의 퍼실리테이터가 함께 접속할 수 있습니다. 시뮬레이션 참관 혹은 그룹 퍼실리테이션 시 활용할 수 있습니다. 전체 과정을 이끌 메인 퍼실리테이터를 정한 뒤 진행하십시오. <br/><br/> 참여자는 로그인 정보를 모두 입력한 뒤 진단을 시작할 수 있습니다. <br/><br/> 참여자가 모두 접속했다면 진단에 대해 설명하십시오. 진단 페이지 하단에서 접속 중인 플레이어의 이름을 확인할 수 있습니다. ",
    "onlyfacilitator": "퍼실리테이터 모드로만 시뮬레이션에 접속하였기 때문에 진단에 참여할 수 없습니다.",
    "opensurveyquestions": "추가질문 표시",
    "opensurveyquestionshelp": "대화의 마무리 단계에서 추가질문을 표시합니다. 질문과 응답결과를 확인하고 보다 깊은 토의를 진행합니다.",
    "cantunpause": "플레이어가 모든 응답을 완료하지 않았습니다. 응답이 완료되면 일시정지를 해제하십시오:",
    "cancel": "취소",
    "playerscasenumber": "시뮬레이션 진행 중인 플레이어",
    "pausedplayers": "일시정지된 플레이어",
    "observeaddress": "관찰자 모드 접속 링크:",
    "opengameselfevaluationsmissing": "자기진단을 완료하지 않은 플레이어가 있습니다. 시뮬레이션을 지금 시작한다면 진단을 완료한 플레이어들만 시작할 수 있습니다. 다른 플레이어는 진단 제출 후 뒤이어 참여할 수 있습니다. 시뮬레이션을 지금 시작하시겠습니까?",
    "pausedplayerforwardhelp": "일시정지된 플레이어는 '다음' 버튼을 클릭하여 다음 주제로 넘어갈 수 있습니다.",
    "rps-facilitatorinfo": "퍼실리테이터는 주로 퍼실리테이터 모드로만 접속합니다. 시뮬레이션에 플레이어로 함께 참여하고 싶다면 다른 옵션을 클릭하세요. <br/><br/> 두 명 이상의 퍼실리테이터가 함께 접속할 수 있습니다. 시뮬레이션 참관 혹은 그룹 퍼실리테이션 시 활용할 수 있습니다. 전체 과정을 이끌 메인 퍼실리테이터를 정한 뒤 진행하십시오. <br/><br/> 참여자는 로그인 정보를 모두 입력한 뒤 진단을 시작할 수 있습니다. <br/><br/>예를 들어 플레이어에게 다음과 같이 말할 수 있습니다. '정보를 입력하면 시뮬레이션이 시작됩니다.",
    "rps-gameclosed": "모든 참가자가 참여하면 버튼을 눌러 시뮬레이션을 계속합니다.",
    "speaking-turns": "참여도 확인 (선택사항)",
    "returnlink": "재접속 링크",
    "email-sent": "이메일이 전송되었습니다hickt"
  }
}
</i18n>

<style scoped>
::v-deep .card-body {
  padding: 6px;
}

.card {
  /* # https://bugs.webkit.org/show_bug.cgi?id=225354 */
  pointer-events: unset !important;
}
</style>
